{"browse_shop":"Bläddra i butiken","go_to_shop":"Gå till butiken","no_orders_found":"Inga beställningar hittades","title":"Order"}